import { connect } from 'react-redux'
import { find } from 'lodash'
import { wisp_public_url as wispPublicUrl } from 'configpath'

import { buildEmail } from 'utils/BuildEmail'

import {
  postEmail,
} from 'reduxpath/ducks/Email'

import {
  setProductAction,
  putProduct,
  getProductById,
  postRejectReason,
  setSelectedClean,
  getPortfolios,
  showError,
} from 'reduxpath/ducks/Product/Detail'

import SetStatus from './units'

const mapStateToProps = (state) => {
  const productStatus = state.ProductList.status
  return {
    statusList: productStatus,
    product: state.ProductDetail,
    status: find(productStatus, { value: state.ProductDetail.data.status })
      || state.ProductList.status.onReview,
    isLoading: state.ProductDetail.isLoading,
    userId: state.Auth.me.user.id,
    data: state.ProductDetail.data,
  }
}

const mapDispatchToProps = dispatch => ({
  handleInputChange() {
    return (e) => {
      const data = {
        field: e.target.name,
        value: e.target.value,
      }
      dispatch(setProductAction(data))
    }
  },
  handleStatus(statusList) {
    return (e) => {
      const data = {
        field: e.target.name,
        value: statusList[e.target.value].value,
      }
      dispatch(setProductAction(data))
    }
  },
  submitStatus(product, selected, userId, statusList) {
    return (e) => {
      e.preventDefault()
      const data = selected
      let status = data.status
      dispatch(getPortfolios(product.data.id, {
        limit: 100000,
        skip: 0,
      }, (res) => {
        const approvedSample = res.rows.filter(
          productPortfolio => productPortfolio.portfolio.status === statusList.approved.value,
        ).length
        if (approvedSample > 0 && data.status === statusList.approved.value) {
          dispatch(putProduct(product.data.id, {
            isEligible: true,
            isOnMarketplaceOnce: true,
          }))
          if (approvedSample !== res.count) {
            status = 0
          }
        }
        if (data.status === statusList.rejected.value) {
          const rejectReason = {
            product: product.data.id,
            rejectReason: data.rejectReason,
            createdBy: userId,
          }
          dispatch(
            postRejectReason(rejectReason, () => {
              const params = {
                user: {
                  email: product.data.createdBy.email,
                  firstName: product.data.createdBy.firstName,
                  profileId: product.data.profile.profileId,
                },
                product: {
                  name: product.data.name,
                  id: product.data.id,
                  slug: product.data.slug,
                },
                rejectReason: data.rejectReason,
              }

              const handlebars = {
                name: params.user.firstName,
                email: params.user.email,
                service_title: params.product.name,
                reason: params.rejectReason,
                service_link: `${wispPublicUrl}/review-redirect/${params.user.profileId}/${params.product.slug}`,
              }
              const emailData = {
                recipient: [{
                  name: params.user.firstName,
                  email: params.user.email,
                }],
                category: 'service-rejected',
                type: 'creator',
                handlebars,
              }
              // TODO move send email to backend
              dispatch(postEmail(buildEmail(emailData)))
            }),
          )
        }
        dispatch(
          putProduct(product.data.id, {
            status,
            reviewedBy: userId,
          }, (updatedProduct) => {
            if (updatedProduct.error === true) {
              dispatch(showError(updatedProduct))
            } else {
              if (data.status === statusList.approved.value) {
                const params = {
                  name: product.data.createdBy.firstName,
                  email: product.data.createdBy.email,
                  service_link: `${wispPublicUrl}/review-redirect/${product.data.profile.profileId}/${product.data.slug}`,
                }
                const emailData = {
                  recipient: [params],
                  category: 'service-approved',
                  type: 'creator',
                  handlebars: params,
                }
                // TODO move send email to backend
                dispatch(postEmail(buildEmail(emailData)))
              }
              dispatch(getProductById(updatedProduct[0].id))
              dispatch(setSelectedClean())
            }
          }),
        )
      }))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SetStatus)
